import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Button from '@minecraft.button';
import Icon from '@minecraft.icon';

const iconSize = (size: string): string => `
  width: ${size};
  height: ${size};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;

  ${media.sm`
  padding: 1rem 0;
  margin: auto;
  width: auto;
  `};
`;

export const EmptyStateTitle = styled.h2`
  margin-bottom: 0.875rem;
`;

export const EmptyStateMessage = styled.p`
  font-size: 1rem;
  margin: 0;
  margin-bottom: 1.25rem;
`;

export const StyledIcon = styled(Icon)`
  ${iconSize('2.5rem')}
  margin-bottom: 1rem;
`;

export const StyledButton = styled(Button)`
  padding: 0 1rem;
  width: 100%;
  margin-top: 0.9375rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  height: 2.5rem;
  align-items: center;

  ${media.sm`
    margin-top: 0;
    width: auto;
    font-size: .875rem;
    height: 2rem;
  `}
`;

export const ButtonLabel = styled.span`
  margin: auto;
`;

export const StyledAddIcon = styled(Icon)`
  ${iconSize('1rem')}

  ${media.sm`
    margin-right: 1rem;
  `}
`;
